import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note26',
  templateUrl: './note26.component.html',
  styleUrls: ['./note26.component.scss'],
})
export class Note26Component implements OnInit {
  note26Form: FormGroup;
  calculativeData: any;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (data.noteId === Notes.Note26) {
        this.calculativeData = data.response.calculativeData;
        if (
          data.response.userInputData !== null &&
          data.response.userInputData !== undefined &&
          data.response.userInputData.data !== null &&
          data.response.userInputData.data !== undefined
        ) {
          this.editNotes26(data.response.userInputData.data);
        }
      }
    });
  }

  editNotes26(res): void {
    this.note26Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : ' ',
      textbox2: res.textbox2 ? res.textbox2 : ' ',
      textbox3: res.textbox3 ? res.textbox3 : ' ',
    });
  }

  setForm(): void {
    this.note26Form = new FormGroup({
      textbox1: new FormControl(''),
      textbox2: new FormControl(''),
      textbox3: new FormControl(''),
    });
  }
}
